import { Injectable } from '@angular/core';
import { CalendarEvent } from 'angular-calendar';
import { Observable } from 'rxjs';
import { ConstantsService } from '../constant/constants.service';
import { GenericCrudService } from '../generic-crud.service';

@Injectable({
	providedIn: 'root'
})
export class AvailabilityService {
	constructor(
		private appConstants: ConstantsService,
		private genericCrudService: GenericCrudService
	) {}

	/**
	 * Récupère la liste des disponibilités
	 * @returns
	 */
	getAllAvailability(
		year: number,
		weekNumber: number
	): Observable<CalendarEvent[]> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.availabilityUrl}/${year}/${weekNumber}`,
			'getAllAvailability'
		);
	}
}
